import { defineMessages, type MessageDescriptor } from 'react-intl';

export const messages: Record<string, MessageDescriptor> = defineMessages({
	project: {
		id: 'relay.jira-dc.project-result.label',
		defaultMessage: 'Project',
		description:
			'Badge label shown on a Jira Data Center project search result to indicate the result type.',
	},
	space: {
		id: 'relay.jira-dc.space-result.label',
		defaultMessage: 'Space',
		description:
			'Badge label shown on a Confluence Data Center space search result to indicate the result type.',
	},
	issue: {
		id: 'relay.jira-dc.issue-result.label',
		defaultMessage: 'Work item',
		description:
			'Badge label shown on a Jira Data Center work item search result to indicate the result type.',
	},
	commment: {
		id: 'relay.jira-dc.comment-result.label',
		defaultMessage: 'Comment',
		description:
			'Badge label shown on a Jira Data Center comment search result to indicate the result type.',
	},
});
